import { NumericFormat, NumericFormatProps } from "react-number-format";
import { felixTokens } from "../../../../theme";

export default function MoedaText(props: NumericFormatProps) {
  const { ...other } = props;

  return (
    <NumericFormat
      displayType={"text"}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale
      valueIsNumericString
      prefix="R$ "
      // Assinatura #1 do sistema: valor monetário sempre em mono tabular.
      style={{
        fontFamily: felixTokens.fontMono,
        fontVariantNumeric: "tabular-nums",
      }}
      {...other}
    />
  );
}
